export const splitUserName = (name = '') => {
  const [firstName, ...lastName] = name.split(' ').filter(Boolean)

  return {
    first_name: firstName,
    last_name: lastName.join(' '),
  }
}
